import { FC } from "react";

import { Option } from "@src/lib/ui/ToggleGroup";
import { Tabs, TabsList, TabsTrigger } from "@src/lib/ui/Tabs";

type Props = {
  tabs: Option<string>[];
  value: string;
  onValueChange: (value: string) => void;
  // Radix Tabs doesn't fire onValueChange when the active tab is re-clicked;
  // this does, so a tab can reset its own sub-navigation.
  onActiveTabClick?: (value: string) => void;
};

const BuilderMainTabsNav: FC<Props> = ({
  tabs,
  value,
  onValueChange,
  onActiveTabClick,
}) => {
  if (tabs.length === 0) return null;

  return (
    <Tabs value={value} onValueChange={onValueChange}>
      <TabsList>
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className="gap-1.5"
            onClick={() => {
              if (tab.value === value) onActiveTabClick?.(tab.value);
            }}
          >
            {tab.icon}
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default BuilderMainTabsNav;
